import includes from "lodash/includes";
import isNumber from "lodash/isNumber";
import styled from "styled-components";
export const SIZES = {
    BTN_SIZE: 28,
    BTN_GROUP_HEIGHT: 22
};
export default {
    ActionsMiniPanel: styled.div
        .withConfig({
        shouldForwardProp: (prop) => !includes(["hasRightSidePanel", "panelHeight"], prop)
    })
        .attrs({
        className: "border-bottom-gray-100"
    }) `
    height: ${({ panelHeight }) => (isNumber(panelHeight) ? `${panelHeight}px` : panelHeight) || "0px"};
    display: grid;
    grid-template-columns: ${({ hasRightSidePanel }) => hasRightSidePanel ? "1fr auto auto" : "1fr auto"};
    align-items: center;
    > * {
      height: ${({ panelHeight }) => (isNumber(panelHeight) ? `${panelHeight}px` : panelHeight) || "0px"};
    }
  `
};
